import { render, staticRenderFns } from "./TestResultForm.vue?vue&type=template&id=11f6675b"
import script from "./TestResultForm.vue?vue&type=script&lang=js"
export * from "./TestResultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports